import styled from 'styled-components';
export const WrapperReceipt = styled.div`
  .page-container {
    position: relative;
    background: white;
    display: block;
    margin-right: -68px;
    margin-left: -68px;
    width: 100%;
    height: 100%;
    page-break-after: always;
    &:first-child {
      margin-top: -68px;
    }
    &:last-child {
      margin-bottom: -68px;
      page-break-after: avoid;
      break-after: avoid;
    }
  }
  .page {
    position: relative;
    background: white;
    display: block;
    margin: 0 auto;
    // margin-bottom: 0.5cm;
    box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
    width: 5.4cm;
    height: 5cm;
  }
  .flex {
    display: flex;
  }
  .flex-column {
    flex-direction: column;
  }
  .flex-1 {
    flex: 1;
  }
  .justify-content-between {
    justify-content: space-between;
  }
  .align-items-center {
    align-items: center;
  }
  .label {
    margin-left: 5px;
  }
  .bold {
    font-weight: bold;
  }

  .logo-box {
    width: 155px;
    margin: auto;
    padding: 38px 0;

    img {
      width: 100%;
    }
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    padding: 0 5px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .card-a {
    margin-bottom: 2px;
    &_box {
      display: flex;
      padding: 2px;
      border: 1px solid #111;
      border-radius: 5px;
      font-size: 9px;
    }
    &_item {
      flex: 1;
      text-align: center;
      border-right: 1px dashed #dddddd;
      &:first-child {
        border-right: none;
      }
    }
    &_label {
      color: #111;
    }
    &_text {
      font-weight: bold;
    }
  }
  .card-b {
    &_box {
      display: flex;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ddd;
      border-radius: 15px;
    }

    &_header {
      display: flex;
      flex: 1;
      &-box {
        padding: 0 0 5px 0;
        border-bottom: 2px solid #ddd;
        margin-bottom: 5px;
      }
      &-item {
        flex: 1;
        text-align: center;
        border-right: 1px dashed #ddd;
        padding: 5px 0;
        &:first-child {
          border-right: none;
        }
        &:last-child {
          flex: 2;
        }
      }
    }
    &_content {
      display: flex;
      flex: 1;
      flex-direction: column;
      &-row {
        display: flex;
        flex: 1;
        margin: 3px 0;
        padding: 3px 0;
        border-bottom: 1px solid #ddd;
        &:last-child {
          border-bottom: none;
          margin: 0;
        }
      }
      &-item {
        flex: 1;
        text-align: center;
        border-right: 1px dashed #ddd;
        padding: 5px 0;
        &:first-child {
          border-right: none;
        }
        &:last-child {
          flex: 2;
        }
      }
    }
  }

  .description {
    min-height: 100px;
    border: 2px solid #ddd;
    border-radius: 15px;
  }
  .sing-box {
    display: flex;
    justify-content: space-between;
    position: absolute;
    padding: 59px 30px;
    bottom: 0;
    left: 0;
    right: 0;
    .item {
      display: flex;
      flex-direction: column;
    }
  }

  #barcode {
    margin-top: -19px;
    & > svg {
      width: 100%;
    }
    & > svg > g > text {
      font-size: 18px !important;
      font-weight: bold !important;
    }
  }

  #postProps {
    font-size: 9px;
    color: black;
  }

  #postWrapper {
    justify-content: center;
    align-items: center;
    padding: 0 10px;
  }

  @media print {
    body {
      width: 21cm;
      height: 25cm;
      // margin: 30mm 45mm 30mm 45mm;
      /* change the margins as you want them to be. */
    }
    .page-container {
      width: 4.5cm;
      height: 4.5cm;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      page-break-after: always;
      &:first-child {
        margin-top: -68px;
      }
      &:last-child {
        margin-bottom: -68px;
      }
    }
    .page {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
`;
